import { devWarn, devError } from '../../../../../utils/devLog';
/**
 * Nakshatra Anga Table Data
 * Based on LakshmiDwadashamshaTableData.ts but for 27 nakshatras with dual rulers system
 * Data from /Users/vn/src/hora/docs/new/nakshatra_anga_table.md
 */

/**
 * Nakshatra Anga attribute interface
 */
export interface NakshatraAngaAttribute {
    number: number;
    name_sanskrit: string;
    name_english: string;
    rulers: string;
    deity: string;
    quality: string;
    path: string;
    direction: string;
}

/**
 * Nakshatra Anga attributes data (27 nakshatras with dual rulers)
 * Based on MahaRishi Bhrigu recommendations
 */
export const NAKSHATRA_ANGA_ATTRIBUTES: NakshatraAngaAttribute[] = [
    {
        number: 1,
        name_sanskrit: "Ашвини",
        name_english: "Ashwini",
        rulers: "Ke Bu",
        deity: "Two Ashwins (transport, healing)",
        quality: "Kshipra (swift)",
        path: "Nripavithi (royal path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 2,
        name_sanskrit: "Бхарани",
        name_english: "Bharani",
        rulers: "Sk Ke",
        deity: "Yama (law, judgment, death)",
        quality: "Ugra (fierce)",
        path: "Nripavithi (royal path)",
        direction: "Adha (downward)"
    },
    {
        number: 3,
        name_sanskrit: "Криттика",
        name_english: "Krittika",
        rulers: "Sy Sk",
        deity: "Agni (fire, ritual)",
        quality: "Mridu-Tikshna (gentle-sharp)",
        path: "Nripavithi (royal path)",
        direction: "Adha (downward)"
    },
    {
        number: 4,
        name_sanskrit: "Рохини",
        name_english: "Rohini",
        rulers: "Ch Sy",
        deity: "Brahma (creation, birth)",
        quality: "Dhruva (stable)",
        path: "Parinamavithi (changing path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 5,
        name_sanskrit: "Мригашира",
        name_english: "Mrigashira",
        rulers: "Ma Ch",
        deity: "Soma (nectar, pleasure)",
        quality: "Mridu (gentle)",
        path: "Parinamavithi (changing path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 6,
        name_sanskrit: "Ардра",
        name_english: "Ardra",
        rulers: "Ra Ma",
        deity: "Rudra (destruction, change)",
        quality: "Tikshna (sharp)",
        path: "Parinamavithi (changing path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 7,
        name_sanskrit: "Пунарвасу",
        name_english: "Punarvasu",
        rulers: "Gu Ra",
        deity: "Aditi (mother, care)",
        quality: "Chara (movable)",
        path: "Prayavithi (path of efforts)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 8,
        name_sanskrit: "Пушйа",
        name_english: "Pushya",
        rulers: "Sa Gu",
        deity: "Brihaspati (teacher, knowledge)",
        quality: "Kshipra (swift)",
        path: "Prayavithi (path of efforts)",
        direction: "Unmukha (upward)"
    },
    {
        number: 9,
        name_sanskrit: "Ашлеша",
        name_english: "Ashlesha",
        rulers: "Bu Sa",
        deity: "Sarpa (poison, mystical power)",
        quality: "Tikshna (sharp)",
        path: "Prayavithi (path of efforts)",
        direction: "Adha (downward)"
    },
    {
        number: 10,
        name_sanskrit: "Магха",
        name_english: "Magha",
        rulers: "Ke Bu",
        deity: "Pitri (lineage, father, ancestors)",
        quality: "Ugra (fierce)",
        path: "Chhanavithi (secret path)",
        direction: "Adha (downward)"
    },
    {
        number: 11,
        name_sanskrit: "Пурва Пхалгуни",
        name_english: "Purva Phalguni",
        rulers: "Sk Ke",
        deity: "Bhaga (luck, gift, wealth)",
        quality: "Ugra (fierce)",
        path: "Chhanavithi (secret path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 12,
        name_sanskrit: "Уттара Пхалгуни",
        name_english: "Uttara Phalguni",
        rulers: "Sy Sk",
        deity: "Aryama (partnership, matchmaking)",
        quality: "Dhruva (stable)",
        path: "Chhanavithi (secret path)",
        direction: "Adha (downward)"
    },
    {
        number: 13,
        name_sanskrit: "Хаста",
        name_english: "Hasta",
        rulers: "Ch Sy",
        deity: "Savitri (inspiration, health)",
        quality: "Kshipra (swift)",
        path: "Jnatavithi (known path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 14,
        name_sanskrit: "Читра",
        name_english: "Chitra",
        rulers: "Ma Ch",
        deity: "Tvashtra (creativity, work)",
        quality: "Mridu (gentle)",
        path: "Jnatavithi (known path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 15,
        name_sanskrit: "Свати",
        name_english: "Swati",
        rulers: "Ra Ma",
        deity: "Vayu (movement, power)",
        quality: "Chara (movable)",
        path: "Jnatavithi (known path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 16,
        name_sanskrit: "Вишакха",
        name_english: "Vishakha",
        rulers: "Gu Ra",
        deity: "Indra-Agni (initiation, ceremony)",
        quality: "Mridu-Tikshna (gentle-sharp)",
        path: "Dirghavithi (long path)",
        direction: "Adha (downward)"
    },
    {
        number: 17,
        name_sanskrit: "Анурадха",
        name_english: "Anuradha",
        rulers: "Sa Gu",
        deity: "Mitra (friendship, help)",
        quality: "Mridu (gentle)",
        path: "Dirghavithi (long path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 18,
        name_sanskrit: "Джйештха",
        name_english: "Jyeshtha",
        rulers: "Bu Sa",
        deity: "Indra (governance, power)",
        quality: "Tikshna (sharp)",
        path: "Dirghavithi (long path)",
        direction: "Vikhya (sideways)"
    },
    {
        number: 19,
        name_sanskrit: "Мула",
        name_english: "Mula",
        rulers: "Ke Bu",
        deity: "Nirriti (calamity, suffering)",
        quality: "Tikshna (sharp)",
        path: "Bahutavithi (multiple path)",
        direction: "Adha (downward)"
    },
    {
        number: 20,
        name_sanskrit: "Пурва Ашадха",
        name_english: "Purva Ashadha",
        rulers: "Sk Ke",
        deity: "Apya (water, ablution)",
        quality: "Ugra (fierce)",
        path: "Bahutavithi (multiple path)",
        direction: "Adha (downward)"
    },
    {
        number: 21,
        name_sanskrit: "Уттара Ашадха",
        name_english: "Uttara Ashadha",
        rulers: "Sy Sk",
        deity: "Vishwa (society, assembly)",
        quality: "Dhruva (stable)",
        path: "Bahutavithi (multiple path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 22,
        name_sanskrit: "Шравана",
        name_english: "Shravana",
        rulers: "Ch Sy",
        deity: "Vishnu (protection, preservation)",
        quality: "Chara (movable)",
        path: "Paravitha (transcendent path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 23,
        name_sanskrit: "Дхаништха",
        name_english: "Dhanishtha",
        rulers: "Ma Ch",
        deity: "Ashta Vasu (8 parts of prosperity)",
        quality: "Chara (movable)",
        path: "Paravitha (transcendent path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 24,
        name_sanskrit: "Шатабхиша",
        name_english: "Shatabhisha",
        rulers: "Ra Ma",
        deity: "Varuna (wisdom, purification)",
        quality: "Chara (movable)",
        path: "Paravitha (transcendent path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 25,
        name_sanskrit: "Пурва Бхадра",
        name_english: "Purva Bhadrapada",
        rulers: "Gu Ra",
        deity: "Aja Ekapada (leadership, first step)",
        quality: "Ugra (fierce)",
        path: "Yuktavithi (uniting path)",
        direction: "Adha (downward)"
    },
    {
        number: 26,
        name_sanskrit: "Уттара Бхадра",
        name_english: "Uttara Bhadrapada",
        rulers: "Sa Gu",
        deity: "Ahirbudhnya (mystery, foundation)",
        quality: "Dhruva (stable)",
        path: "Yuktavithi (uniting path)",
        direction: "Unmukha (upward)"
    },
    {
        number: 27,
        name_sanskrit: "Ревати",
        name_english: "Revati",
        rulers: "Bu Sa",
        deity: "Pushan (path, search, fertility)",
        quality: "Mridu (gentle)",
        path: "Yuktavithi (uniting path)",
        direction: "Vikhya (sideways)"
    }
];

/**
 * Calculate nakshatra index (1-27) from longitude (0-360°)
 * Uses traditional Vedic calculation where each nakshatra is 360°/27 = 13.333°
 */
export function getNakshatraIndexFromLongitude(longitude: number): number {
    // Normalize longitude to 0-360 range
    const normalizedLongitude = ((longitude % 360) + 360) % 360;

    // Each nakshatra is 13.333... degrees (360/27)
    const nakshatraSize = 360 / 27;

    // Calculate nakshatra index (0-26) then convert to 1-based (1-27)
    const nakshatraIndex = Math.floor(normalizedLongitude / nakshatraSize) + 1;

    // Ensure result is in valid range (1-27)
    return Math.max(1, Math.min(27, nakshatraIndex));
}

/**
 * Parse longitude from position string (reused from LakshmiDwadashamshaTableData)
 */
export function parseLongitudeFromPosition(position: string): number | null {
    try {
        // Position format: "Mesha|15° 30' 45"|345.5125|0.02"
        const parts = position.split('|');
        if (parts.length >= 3) {
            const longitudeStr = parts[2]; // "345.5125"
            const longitude = parseFloat(longitudeStr);

            if (!isNaN(longitude)) {
                return longitude;
            }
        }

        devWarn('⚠️ Failed to parse longitude from position:', position);
        return null;
    } catch (error) {
        devError('❌ Error parsing longitude from position:', position, error);
        return null;
    }
}

/**
 * Tara Phala attribute interface
 */
export interface TaraPhalaAttribute {
    number: number;
    name_sanskrit: string;
    name_english: string;
    meaning: string;
}

/**
 * Tara Phala attributes (9 cyclic values)
 * Classical Vedic system where Chandra's nakshatra = Tara 1, then cycles 1-9 repeatedly
 */
export const TARA_PHALA_ATTRIBUTES: TaraPhalaAttribute[] = [
    {
        number: 1,
        name_sanskrit: "Jānmā",
        name_english: "Janma",
        meaning: "birth, beginning, source"
    },
    {
        number: 2,
        name_sanskrit: "Sampat",
        name_english: "Sampat",
        meaning: "success, luck, achievements"
    },
    {
        number: 3,
        name_sanskrit: "Vipat",
        name_english: "Vipat",
        meaning: "failure, disaster, deviation"
    },
    {
        number: 4,
        name_sanskrit: "Kṣema",
        name_english: "Kshema",
        meaning: "comfort, peace, happiness"
    },
    {
        number: 5,
        name_sanskrit: "Pratipā",
        name_english: "Pratipa",
        meaning: "enmity, resistance, opposition"
    },
    {
        number: 6,
        name_sanskrit: "Sādhana",
        name_english: "Sadhana",
        meaning: "direct path, practice, achievement"
    },
    {
        number: 7,
        name_sanskrit: "Naidhana",
        name_english: "Naidhana",
        meaning: "destruction, loss, ending"
    },
    {
        number: 8,
        name_sanskrit: "Mitra",
        name_english: "Mitra",
        meaning: "friendship, partnership, alliance"
    },
    {
        number: 9,
        name_sanskrit: "Parama",
        name_english: "Parama",
        meaning: "important, main task, best"
    }
];

/**
 * Calculate Tara Phala for a nakshatra relative to Chandra's nakshatra
 * Classic Vedic cyclic system: Chandra = Tara 1, then 2, 3... 9, 1, 2, 3... (cycling)
 *
 * @param nakshatraIndex - Target nakshatra (1-27)
 * @param chandraNakshatraIndex - Chandra's nakshatra (1-27)
 * @returns Tara Phala number (1-9)
 */
export function getTaraPhalaForNakshatra(nakshatraIndex: number, chandraNakshatraIndex: number): number {
    // Calculate distance from Chandra's nakshatra (allowing wrap-around)
    // Example: If Chandra in 4, nakshatra 5 is distance 1, nakshatra 3 is distance 26
    const distance = ((nakshatraIndex - chandraNakshatraIndex + 27) % 27);

    // Map distance to Tara (1-9 cycle)
    // Distance 0 (same as Chandra) = Tara 1
    // Distance 1 = Tara 2
    // Distance 8 = Tara 9
    // Distance 9 = Tara 1 (cycle repeats)
    const taraIndex = (distance % 9) + 1;

    return taraIndex;
}

/**
 * Get Tara Phala attribute by Tara number (1-9)
 */
export function getTaraPhalaAttribute(taraNumber: number): TaraPhalaAttribute | null {
    if (taraNumber < 1 || taraNumber > 9) {
        devWarn(`⚠️ Invalid Tara number: ${taraNumber}, expected 1-9`);
        return null;
    }
    return TARA_PHALA_ATTRIBUTES[taraNumber - 1];
}